import React, { useRef } from 'react';
import styled from 'styled-components';
import { PaperBlurFitBtn } from './headless/button/BtnBody';
import { useEditMode } from '../hooks/useEditMode';
import { getBtnName } from '../constants/btnNames';
import { getImageDimensions } from '../util/imageUtils';

export interface ReplaceImageButtonProps {
  setImageUrl: (originUrl: string, width: number, height: number) => void;
  setImageFile?: (file: File, width: number, height: number) => void;
}

const ReplaceImageButton: React.FC<ReplaceImageButtonProps> = ({ setImageUrl, setImageFile }) => {
  const { isEditMode } = useEditMode();
  const fileInputRef = useRef<HTMLInputElement>(null);


  const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;

    if (setImageFile) {
      const { width, height } = await getImageDimensions(file);
      setImageFile(file, width, height);
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const localImageUrl = reader.result as string; // FileReader의 결과는 string 타입
      const img = new Image();
      img.onload = () => {
        setImageUrl(localImageUrl, img.width, img.height); // 로컬 URL과 이미지 크기를 전달
      };
      img.src = localImageUrl;
    };
    reader.readAsDataURL(file); // 파일을 Data URL로 읽기
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  if (!isEditMode) {
    return null;
  }

  return (
    <>
      <BtnWrapper>
        <PaperBlurFitBtn onClick={triggerFileInput}>
          {getBtnName('REPLACE_IMAGE')}
        </PaperBlurFitBtn>
      </BtnWrapper>
      <HiddenFileInput
        type="file"
        ref={fileInputRef}
        onChange={handleImageChange}
        accept="image/*"
      />
    </>
  );
};

const BtnWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`

const HiddenFileInput = styled.input`
  display: none;
`;


export default ReplaceImageButton;
